import { render, staticRenderFns } from "./ResumoClienteDadosGerais.vue?vue&type=template&id=19f7b25d"
import script from "./ResumoClienteDadosGerais.vue?vue&type=script&lang=js"
export * from "./ResumoClienteDadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports